<template>
  <div class="p-6">
    <div class="flex justify-between items-center mb-6">
      <h1 class="text-2xl font-bold text-gray-800">Dashboard de Órdenes de Compra</h1>
      <div class="flex space-x-4 items-center">
        <input type="date" v-model="fecha_inicio" class="px-4 py-2 border rounded">
        <input type="date" v-model="fecha_fin" class="px-4 py-2 border rounded">
        <button @click="cargarDatos" class="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600">Consultar</button>
      </div>
    </div>

    <div class="bg-white rounded-lg shadow p-6 mb-6">
      <h2 class="text-xl font-semibold mb-4">Resumen de Órdenes de Compra</h2>
      <p class="text-gray-600 mb-4">
        Este dashboard muestra un análisis detallado de las órdenes de compra, incluyendo el consumo total por proveedor, 
        categoría de producto y productos individuales.
      </p>
      
      <div v-if="loading" class="text-center py-10">
        <p>Cargando datos...</p>
      </div>

      <div v-if="!loading && !error" class="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
        <div class="border rounded-lg p-4">
          <h3 class="font-semibold mb-3">Consumo por Proveedor</h3>
          <apexchart type="pie" :options="chartOptionsProveedores" :series="seriesProveedores"></apexchart>
        </div>

        <div class="border rounded-lg p-4">
          <h3 class="font-semibold mb-3">Consumo por Categoría</h3>
          <apexchart type="bar" :options="chartOptionsCategorias" :series="seriesCategorias"></apexchart>
        </div>

        <div class="md:col-span-2 border rounded-lg p-4">
          <h3 class="font-semibold mb-3">Detalle de Productos</h3>
          <div class="overflow-x-auto">
            <table class="min-w-full bg-white">
              <thead>
                <tr class="bg-gray-100">
                  <th class="py-2 px-4 text-left">Producto</th>
                  <th class="py-2 px-4 text-right">Monto Total</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="consumoPorProducto.length === 0">
                    <td colspan="2" class="text-center py-4">No hay datos disponibles.</td>
                </tr>
                <tr v-for="item in consumoPorProducto" :key="item.producto" class="border-t">
                  <td class="py-2 px-4">{{ item.producto }}</td>
                  <td class="py-2 px-4 text-right">${{ parseFloat(item.total_consumido).toLocaleString('es-MX') }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
       <div v-if="error" class="text-center py-10 text-red-500">
        <p>{{ error }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import reportesNuevos from '@/Services/reportesNuevos.js';
import VueApexCharts from 'vue3-apexcharts';

export default {
  name: 'DashboardOrdenesCompra',
  components: {
    apexchart: VueApexCharts,
  },
  data() {
    const endDate = new Date();
    const startDate = new Date();
    startDate.setDate(endDate.getDate() - 30);

    return {
      fecha_inicio: startDate.toISOString().split('T')[0],
      fecha_fin: endDate.toISOString().split('T')[0],
      loading: false,
      error: null,
      consumoPorProveedor: [],
      consumoPorCategoria: [],
      consumoPorProducto: [],
      seriesProveedores: [],
      chartOptionsProveedores: {
        chart: { type: 'pie' },
        labels: [],
        responsive: [{
          breakpoint: 480,
          options: {
            chart: { width: 200 },
            legend: { position: 'bottom' }
          }
        }]
      },
      seriesCategorias: [{ name: 'Consumo', data: [] }],
      chartOptionsCategorias: {
        chart: { type: 'bar' },
        xaxis: { categories: [] },
        plotOptions: { bar: { horizontal: true } },
        dataLabels: { enabled: false },
      },
    };
  },
  methods: {
    async cargarDatos() {
      this.loading = true;
      this.error = null;
      try {
        const response = await reportesNuevos.DASHBOARD_ORDENES_COMPRA({
          fecha_inicio: this.fecha_inicio,
          fecha_fin: this.fecha_fin,
        });

        if (response.data.errors) {
            this.error = Object.values(response.data.errors).join(', ');
            this.consumoPorProveedor = [];
            this.consumoPorCategoria = [];
            this.consumoPorProducto = [];
            this.seriesProveedores = [];
            this.chartOptionsProveedores.labels = [];
            this.seriesCategorias = [{ data: [] }];
            this.chartOptionsCategorias.xaxis.categories = [];
            return;
        }

        const { consumo_por_proveedor, consumo_por_categoria, consumo_por_producto } = response.data;
        
        this.consumoPorProveedor = consumo_por_proveedor;
        this.consumoPorCategoria = consumo_por_categoria;
        this.consumoPorProducto = consumo_por_producto;

        // Update chart data
        this.seriesProveedores = this.consumoPorProveedor.map(p => parseFloat(p.total_consumido));
        this.chartOptionsProveedores = { ...this.chartOptionsProveedores, labels: this.consumoPorProveedor.map(p => p.proveedor) };

        this.seriesCategorias = [{ data: this.consumoPorCategoria.map(c => parseFloat(c.total_consumido)) }];
        this.chartOptionsCategorias = { ...this.chartOptionsCategorias, xaxis: { categories: this.consumoPorCategoria.map(c => c.categoria) } };

      } catch (error) {
        console.error('Error al cargar datos:', error);
        this.error = 'No se pudieron cargar los datos. Intente de nuevo más tarde.';
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    this.cargarDatos();
  },
};
</script>

<style scoped>
/* Estilos específicos para este componente */
</style>
